module.exports = __webpack_public_path__ + "img/infographic.13608876.jpg";